<template>
  <div class="tender-section" :section="section.Title">
    <div :class="`tender-site-title tender-section-${chapterIndex}-${sectionIndex}`"></div>
    <el-form ref="form" :model="form" inline>
      <component :is="chapterComponent">
        <template #form-item="scope">
          <tender-form-item
            :ref="scope.key"
            :chapter-index="chapterIndex"
            :section-index="sectionIndex"
            :property-key="scope.key"
            :attrs="scope"
            @action="action">
          </tender-form-item>
        </template>
      </component>
    </el-form>
    <br />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import TenderFormItem from "./tender-form-item";
export default {
  name: "TenderSection",
  components: {
    TenderFormItem,
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0,
    },
    sectionIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    ...mapState(["form", "validatorCount", "chapterComponents"]),
    ...mapGetters(["chapters", "properties"]),
    section() {
      let { chapters, chapterIndex, sectionIndex } = this;
      return chapters[chapterIndex].Sections[sectionIndex];
    },
    chapterComponent() {
      let { chapterIndex, sectionIndex } = this;
      return this.chapterComponents[chapterIndex][sectionIndex];
    },
  },
  methods: {
    async validate() {
      this.count = 1;
      return await new Promise((resolve, reject) => {
        this.$refs.form
          .validate()
          .then((e) => resolve(true))
          .catch((e) => resolve(false));
      });
    },
    validateForm() {
      this.$refs.form.validate().then((e) => {
        this.setTenderCountByIndex(0);
      }).catch((e) => {
        let list = [];
        for (let i in e) {
          if (e[i] && e[i] instanceof Array) list.push(e[i]);
        }
        this.setTenderCountByIndex(list.length);
      });
    },
    setTenderCountByIndex(fail) {
      let { chapterIndex, sectionIndex } = this;
      let total = this.countFormItemRequired();
      
      this.$store.dispatch("setTenderCountByIndex", { chapterIndex, sectionIndex, total, fail });
    },
    formItemRefs() {
      let formItems = Object.keys(this.$refs);
      if (this.count >= 0) return formItems.filter((key) => this.$refs[key] && ["form"].indexOf(key) === -1);
      return [];
    },
    countFormItemRequired() {
      let formItemRefs = this.formItemRefs();
      return formItemRefs.reduce((preValue, prop) => {
        return preValue + this.getRequiredCount(prop);
      }, 0);
    },
    getRequiredCount(key) {
      let $formItem = this.$refs[key];
      if ($formItem) {
        if ($formItem.length) {
          return $formItem[0].getRequiredCount(key);
        } else {
          return $formItem.getRequiredCount(key);
        }
      }
      return 1;
    },
    action(type, obj) {
      switch (type) {
        case "validate":
          this.validateForm();
          break;
      }
    },
  },
  watch: {
    validatorCount() {
      this.validateForm();
    },
  },
};
</script>
<style lang="scss" scoped>
.tender-section {
  margin-bottom: 15px;
  padding: 30px;
  background: white;
  box-shadow: 0px 0px 5px 1px #aaabaf;
  page-break-before: always;
  page-break-inside: avoid;
  page-break-after: always;
  .ts-title {
    margin: 20px 0;
    text-align: center;
    font: bold 21px/30px simsun;
  }
}
</style>